import { useCallback, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { SmallButton } from '@/components/Button';
import { SetsModal } from '@/components/SetsModal';
import colors from '@/config/colors';

export function NoSets() {
  // state
  const [isSetsModalVisible, setIsSetsModalVisible] = useState(false);

  // methods
  const changeSetsModalVisibility = useCallback((value) => {
    if (!value) return setIsSetsModalVisible((prevState) => !prevState);
    setIsSetsModalVisible(value);
  }, []);

  const handleShowModalPress = useCallback(() => {
    changeSetsModalVisibility(true);
  }, []);

  return (
    <>
      <View style={styles.noSetsView}>
        <Text style={styles.noSetsTitleText}>
          Noch keine Übungssets erstellt
        </Text>
        <SmallButton
          icon="plusCircle"
          label="Neues Set erstellen"
          onPress={handleShowModalPress}
        />
      </View>
      <SetsModal
        isSetsModalVisible={isSetsModalVisible}
        changeSetsModalVisibility={changeSetsModalVisibility}
      />
    </>
  );
}

const styles = StyleSheet.create({
  noSetsTitleText: {
    fontSize: 22,
    fontWeight: '700',
    color: colors.darkGrey,
    marginBottom: 24,
  },
  noSetsView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
